import React from "react";
import styled from "styled-components";
import {
  Row,
  Col,
  Typography,
  Button,
  Space,
  Divider,
  Skeleton,
  message,
} from "antd";
import { BsGlobe } from "react-icons/bs";
import { FaLinkedinIn } from "react-icons/fa";
import {
  MdAccountBox,
  MdEmail,
  MdPhone,
  MdArrowDropDownCircle,
} from "react-icons/md";
import HSCodes from "../BuyerRecommendations/BuyerDetails/HSCodes";
import Stats from "../BuyerRecommendations/BuyerDetails/Stats";
import TradingPartners from "../BuyerRecommendations/BuyerDetails/TradingPartners";
import OtherTradingPartners from "../BuyerRecommendations/BuyerDetails/OtherTradingPartners";
import HSCodeDistribution from "../BuyerRecommendations/BuyerDetails/HSCodeDistribution";
import DIRECTUS from "api/index";
import { capitalize } from "utils/randomString";
const { Title, Text } = Typography;
const Container = styled.div`
  padding: 1.5em;
  background: #ffffff;
  border: 1px solid #cdcfce;
  border-radius: 8px;
`;
export default function ProspectDetail({
  data,
  loadMore,
  setLoadMore,
  loadingBuyer,
  buyerData,
  fetchProspects,
  contactData,
}) {
  const prospesctData = {
    ...data,
    hsCode: [570242, 570243, 570244, 570245, 570246],
    website: "www.sourcewiz.co",
    contactDetails: [
      {
        name: "Mayur Sonawane",
        email: "mayur.sonawane@sourcewiz.co",
        phone: "+1-234-567-8901",
        address: "123 Main St, New York, NY 10001",
        linkedIn: "https://www.linkedin.com/in/mayur-sonawane-a271b2114/",
        designation: "Software Engineer",
      },
      {
        name: "Deepam Patel",
        email: "deepam@sourcewiz.co",
        phone: "+1-234-567-8901",
        address: "123 Main St, New York, NY 10001",
        linkedIn: "https://www.linkedin.com/in/deepam-patel",
        designation: "Software Engineer",
      },
    ],
  };

  var flatArray;
  var mostImportedProduct;
  var hsCodes;
  const pref = localStorage.getItem("pref");
  const userHsCode = JSON.parse(pref)?.hs_code;
  const city = JSON.parse(pref)?.city;
  var tradingPartner;
  if (buyerData?.trading_partners) {
    tradingPartner =
    buyerData?.trading_partners?.find(
        (item) =>
          item?.city?.toLowerCase() === city?.toLowerCase() ||
          item?.city?.toLowerCase().includes(city?.toLowerCase())
      ) || buyerData?.trading_partners?.[0];
  }
  if (buyerData?.hscode_distribution) {
    flatArray = Object.assign(...buyerData?.hscode_distribution);
    const max = Math.max.apply(Math, Object.values(flatArray));
    const hsCode = Object.keys(flatArray).find((key) => flatArray[key] === max);
    hsCodes = Object.assign(...buyerData?.hscode_description);
    mostImportedProduct = hsCodes[hsCode];
  }
  const handleRemove = (id) => {
    DIRECTUS.URL.delete(`${DIRECTUS.path.prospects}/${id}`)
      .then((res) => {
        fetchProspects();
      })
      .catch((err) => console.log("err", err));
  };

  return (
    <Container>
      <Row justify="space-between">
        <Col>
          <Title level={4}>
            {capitalize(prospesctData?.name)}
            {prospesctData?.name && prospesctData?.country && `, `}
            {capitalize(prospesctData?.country)}
          </Title>
        </Col>
        <Col>
          <Button onClick={() => handleRemove(data?.id)}>
            Remove prospect
          </Button>
        </Col>
      </Row>
      {/* <Row>
        <Col>
          <Text type="secondary">
            <Space>
              <BsGlobe size={20} />
              <Text type="secondary">Website link</Text>
              <Text copyable type="secondary">
                {prospesctData?.website}
              </Text>
            </Space>
          </Text>
        </Col>
      </Row> */}
      <Divider style={{ color: "#E6E7E7" }} />

      <Row>
        <Col span={24}>
          {loadingBuyer ? (
            <Skeleton.Button active style={{ width: "100%" }} />
          ) : (
            <HSCodes
              data={buyerData}
              hsCodes={
                buyerData && Object.assign(...buyerData?.hscode_description)
              }
              userHsCode={userHsCode}
            />
          )}
        </Col>
      </Row>

      {contactData?.length > 0 ? (
        <ContactDetails prospesctData={contactData?.[0]} />
      ) : (
        <Row
          justify="center"
          align="middle"
          style={{
            marginTop: "1.5em",
            background: "#F8FAF7",
            padding: "1.5em",
            
          }}
        >
         <Col>
         <Row justify="space-between" align="middle" >
          <Space>
          <Col>
            <MdAccountBox size={50} color="#9B9F9E" />
            </Col>
            <Col>
            <Row>
              <Title level={4} style={{margin:0}} >Request for contact details sent</Title>
            </Row>
            <Row>
              <Text>
              We are searching contact details for this buyer. Our team will notify on email once found.
              </Text>
            </Row>
          </Col>
         
          </Space>
          </Row>
          </Col>
          
        </Row>
      )}

      {loadMore && (
        <>
          <Row style={{ marginTop: "1em" }}>
            <Col span={24}>
              {loadingBuyer ? (
                <Skeleton active />
              ) : (
                <Stats
                  data={buyerData}
                  hscode_distribution={buyerData?.hscode_distribution}
                  hscode_description={buyerData?.hscode_description}
                  mostImportedProduct={mostImportedProduct}
                />
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: "1em" }}>
            <Col span={24}>
              {loadingBuyer ? (
                <Skeleton active />
              ) : (
                <TradingPartners
                data={tradingPartner}
                trading_partners={buyerData?.trading_partners}
                overall_trade_value={buyerData?.overall_trade_value}
              />
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: "1em" }}>
            <Col span={24}>
              {loadingBuyer ? (
                <Skeleton active />
              ) : (
                <OtherTradingPartners data={buyerData?.trading_partners} />
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: "1em" }}>
            <Col span={24}>
              {loadingBuyer ? (
                <Skeleton active />
              ) : (
                <HSCodeDistribution
                  data={buyerData?.hscode_distribution}
                  hsCodes={hsCodes}
                  flatArray={flatArray}
                />
              )}
            </Col>
          </Row>
        </>
      )}
      <Row style={{ marginTop: "1.5em" }}>
        <Col>
          {loadMore ? (
            <Row
              align="middle"
              justify="space-between"
              style={{ cursor: "pointer" }}
              onClick={() => setLoadMore(false)}
            >
              <Text link>View less details</Text>
              <MdArrowDropDownCircle
                size={22}
                color="#0B7764"
                style={{ marginLeft: 5 }}
              />
            </Row>
          ) : (
            <Row
              align="middle"
              justify="space-between"
              style={{ cursor: "pointer" }}
              onClick={() => setLoadMore(true)}
            >
              <Text link>View more details</Text>
              <MdArrowDropDownCircle
                size={22}
                color="#0B7764"
                style={{ marginLeft: 5 }}
              />
            </Row>
          )}
        </Col>
      </Row>
    </Container>
  );
}

const ContactDetails = ({ prospesctData }) => {
  const copyText = async (text) => {
    await navigator.clipboard.writeText(text);
    message.success("Copied to clipboard");
  };
  return (
    <Row
      style={{ marginTop: "1.5em", background: "#F8FAF7", padding: "1.5em" }}
    >
      <Col span={24}>
        <Space>
          <MdAccountBox size={24} color="#14453C" />
          <Title level={4}>Contact Details</Title>
        </Space>
      </Col>
      <Divider />

      <Col span={24}>
        {prospesctData?.contact_provider.map((item, index) => (
          <>
            {console.log("item", item)}
            <Row key={index}>
              <Col span={24}>
                <Title level={4}>
                  {item?.first_name} {item?.last_name}
                </Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Title level={5} type="secondary">
                  {item?.designation}
                </Title>
              </Col>
            </Row>
            <Row gutter={4}>
              {/* linkedIn */}
              {item?.url && (
                <Col span={8}>
                  <Row>
                    <Col span={2}>
                      <FaLinkedinIn size={20} />
                    </Col>
                    <Col span={16} push={2}>
                      <Row>
                        <Text ellipsis>{item?.url}</Text>
                      </Row>
                      <Row>
                        <Button
                          type="link"
                          style={{ padding: 0 }}
                          onClick={() => copyText(item?.url)}
                        >
                          Copy link
                        </Button>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )}

              {/* email */}
              {item?.email && (
                <Col span={8}>
                  <Row>
                    <Col span={2}>
                      <MdEmail size={20} />
                    </Col>
                    <Col span={16} push={2}>
                      <Row>
                        <Text ellipsis>{item?.email}</Text>
                      </Row>
                      <Row>
                        <Button
                          type="link"
                          style={{ padding: 0 }}
                          onClick={() => copyText(item?.email)}
                        >
                          Copy link
                        </Button>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )}

              {/* phone */}
              {item?.contact_number && (
                <Col span={8}>
                  <Row>
                    <Col span={2}>
                      <MdPhone size={20} />
                    </Col>
                    <Col span={16} push={2}>
                      <Row>
                        <Text ellipsis>{item?.contact_number}</Text>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>

            {prospesctData?.contact_provider?.length - 1 !== index && (
              <Divider />
            )}
          </>
        ))}
      </Col>
    </Row>
  );
};
